import { connect } from 'react-redux';
import { isOrganizerQuestionsPage } from '../../selectors/routing';
import { CheckoutState } from '../../state';
import Page from '../Page';

const _mapStateToProps = (state: CheckoutState) => ({
    isOrganizerQuestionsPage: isOrganizerQuestionsPage(state),
});

export const connectOrganizerQuestionsPageChecker = (
    ComponentClass: React.Component<Page>,
) => connect(_mapStateToProps)(ComponentClass);
